import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Input } from '@web-common/components/UI/Input';
import { apiHolder as api, apis } from 'api';
import { getIn18Text } from 'api';
import Styles from './verify-code.module.scss';
const loginApi = api.api.requireLogicalApi(apis.loginApiImpl);
function getVerifyCodeUrl() {
    return loginApi.getLoginVefifyCodeUrl();
}
const VerifyCode = React.forwardRef(({ onChange, onVerifyCodeLoadError }, ref) => {
    let [verifyCodeUrl, setVerifyCodeUrl] = useState();
    useEffect(() => {
        updateVerifyCode();
    }, []);
    const updateVerifyCode = () => {
        let newVerifyCodeUrl = getVerifyCodeUrl();
        setVerifyCodeUrl(newVerifyCodeUrl);
    };
    useImperativeHandle(ref, () => {
        return {
            refreshVerifyImgCode() {
                updateVerifyCode();
            },
        };
    });
    const handleVerifyCodeError = () => {
        onVerifyCodeLoadError();
    };
    return (React.createElement("div", { className: Styles.mainContainer },
        React.createElement(Input, { className: Styles.codeInput, onChange: ev => {
                onChange && onChange(ev.target.value);
            }, placeholder: getIn18Text('QINGSHURUYANZHENG') }),
        React.createElement("img", { className: Styles.codeImg, alt: getIn18Text('YANZHENGMA'), title: getIn18Text('DIANJISHUAXINYAN'), onError: handleVerifyCodeError, src: verifyCodeUrl, onClick: updateVerifyCode })));
});
export default VerifyCode;
